import { lazy } from 'react'
import { Route } from 'react-router-dom'
import { pageUrl } from '@/constants/url'

const SettingsPage = lazy(() => import('./pages/index'))
const SettingsPaymentTypesPage = lazy(() => import('./pages/paymentTypes'))
const SettingsBranch = lazy(() => import('./pages/settingsBranch'))
const BookingWebsitePage = lazy(() => import('./pages/bookingWebsite'))
const BlockedTimesPage = lazy(() => import('./pages/blockedTimes'))
const SettingTaxesPage = lazy(() => import('./pages/settingsTaxes'))
const ServiceChargesPage = lazy(() => import('./pages/serviceCharges'))
const AuditLogsPage = lazy(() => import('./pages/auditLogs'))
const SettingsPrinterPage = lazy(() => import('./pages/settingsPrinter'))

// Load translations immediately when this module is imported

export const settingsRoutes = () => {
  return (
    <>
      <Route path={pageUrl.settings} element={<SettingsPage />} />
      <Route
        path={pageUrl.settingsPaymentTypes}
        element={<SettingsPaymentTypesPage />}
      />
      <Route path={pageUrl.settingsBranch} element={<SettingsBranch />} />
      <Route path={pageUrl.bookingWebsite} element={<BookingWebsitePage />} />
      <Route path={pageUrl.settingBlockedTime} element={<BlockedTimesPage />} />
      <Route path={pageUrl.settingsTaxes} element={<SettingTaxesPage />} />
      <Route path={pageUrl.settingsPrinter} element={<SettingsPrinterPage />} />
      <Route
        path={pageUrl.settingsServiceCharges}
        element={<ServiceChargesPage />}
      />
      <Route path={pageUrl.auditLogs} element={<AuditLogsPage />} />
    </>
  )
}
